var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWaermekonto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.98,
    height: 27.486,
    viewBox: "0 0 27.98 27.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-786.551 -920.156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.551,16.211l-.025-.025L11.441,26.272,4.786,19.615,14.852,9.548l.018-.018L13.077,7.738,13.06,7.72.018,20.762,0,20.78,13.058,33.838,26.1,20.8l.016-.018Z",
    transform: "translate(786.551 913.805)",
    fill: "#124395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.892,1.64,36.668,14.407l-.018.018L38.123,15.9l.018.018L50.926,1.674Z",
    transform: "translate(756.397 918.807)",
    fill: "#e63027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.217,0,56.258,16.531l-.018.018,1.473,1.475.018.018L74.251.034Z",
    transform: "translate(740.28 920.156)",
    fill: "#e63027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.548.83,46.418,15.475l-.018.018,1.473,1.473.018.019L62.581.864Z",
    transform: "translate(748.376 919.473)",
    fill: "#e63027"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaermekonto);
export default __webpack_public_path__ + "static/media/icon-waermekonto.cda238334493fc8cd2703b21b1ceec4a.svg";
export { ForwardRef as ReactComponent };